import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanCurrency } from 'store/useBusinessToolStore/selectors';

export const useGetCurrency = () => {
  return useBusinessToolStore(getBusinessPlanCurrency);
};
